import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import { OmniHub } from "./pages/omnihub";
import ScannerPage from "./pages/scanner/ScannerPage";
import MobileDALPage from "./pages/mobile/MobileDALPage";
import MobileVisitePage from "./pages/mobile/MobileVisitePage";
import VisiteRenovation from "./pages/renovation/VisiteRenovation";
import SetPasswordPage from "./pages/SetPasswordPage";
import DashboardTestPage from "./pages/DashboardTestPage";
import OhCharteGallery from "./pages/dev/OhCharteGallery";
// Agentic — écran Missions. ⚠️ Route DIRECTE, ⛔ aucune entrée de menu ajoutée :
// la navigation appartient aux autres lanes, et l'écran doit être atteignable
// sans réorganiser quoi que ce soit. Un composant non routé serait un écran
// MORT — le défaut même qu'il corrige côté API.
import MissionsAgentic from "./components/agentic/MissionsAgentic";
import { PWAStatus } from "./components/PWAStatus";
import ErrorBoundary from "./components/ErrorBoundary";
import { installSafeToast } from "./lib/safeToast";

// Incident #314 — point de passage UNIQUE des messages d'erreur.
// Patche `toast` (singleton de module sonner) une fois, au chargement du
// module App : les 163 appels des 82 écrans en héritent sans être modifiés.
// Doit rester AVANT tout rendu — un toast ne peut pas partir plus tôt.
installSafeToast();

function ThemedToaster() {
  const { theme } = useTheme();
  return (
    <Toaster 
      position="bottom-right" 
      theme={theme}
      toastOptions={{
        style: theme === 'dark' ? {
          background: '#0a0a0a',
          border: '1px solid rgba(255,255,255,0.1)',
          color: '#fff'
        } : {
          background: '#ffffff',
          border: '1px solid rgba(0,0,0,0.1)',
          color: '#18181b'
        }
      }}
    />
  );
}

function App() {
  return (
    <ErrorBoundary>
    <ThemeProvider>
      <div className="min-h-screen" style={{ backgroundColor: 'var(--oh-bg)' }}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/hub" replace />} />
              <Route path="/login" element={<Navigate to="/hub" replace />} />
              {/* Routes spécifiques DOIVENT précéder /hub/* catch-all */}
              <Route path="/hub/dashboard-test/:hubName?" element={<DashboardTestPage />} />
              <Route path="/hub/*" element={<OmniHub />} />
              <Route path="/scanner" element={<ScannerPage />} />
              {/* Recette charte — galerie des composants normés (lecture seule, sans effet de bord). */}
              <Route path="/charte-gallery" element={<OhCharteGallery />} />
              <Route path="/agentic/missions" element={<MissionsAgentic />} />
              {/* D4 — décision JJ : PAS de formulaire public anonyme. La saisie
                  externe passe par le compte RÉGIE authentifié (role="regie",
                  écran RegieProspectForm dans OmniHub). L'ancienne route /form/:slug
                  (public non-auth) est retirée ; d4_public backend reste dormant. */}
              <Route path="/set-password" element={<SetPasswordPage />} />
              <Route path="/mobile/dal" element={<MobileDALPage />} />
              {/* 🔴 VISITE MOBILE — le module TERRAIN (Mario). Même convention
                  de route que le DAL mobile : `/mobile/<module>`, ⛔ pas une
                  seconde mécanique de navigation. */}
              <Route path="/mobile/visite" element={<MobileVisitePage />} />
              {/* 🔴 « Visite Rénovation » — relevé chantier TERRAIN (numéro de dossier + code ⇒
                  jeton borné au dossier). Moteur `chantier/` SEUL : ⛔ DAL, ⛔ MobileVisitePage. */}
              <Route path="/mobile/renovation" element={<VisiteRenovation />} />
              {/* 🔴 N°975 — l'ANCIEN point d'entrée terrain (`/mobile/chantier`, liens SMS de
                  mission) ⛔ n'existe plus ici : sans cette route, une icône PWA ou un lien
                  installé avant la bascule ouvrait une page VIDE (N°976 : Mario bloqué 6 fois
                  sur l'écran « accès mission », missions expirées). Toutes ses formes (nue,
                  `/m/:missionId`, `#c=…`) mènent au parcours ACTIF. Même motif que `/audrey/*`. */}
              <Route path="/mobile/chantier/*" element={<Navigate to="/mobile/renovation" replace />} />
              {/* Landing legacy Audrey supprimée (décision CTO : doublon mort du
                  Cockpit Audrey officiel du Hub). Redirection permanente vers la vraie
                  landing /hub pour que les marque-pages existants ne tombent pas en 404.
                  Même motif que "/" et "/login" ci-dessus ; le splat couvre la route
                  nue et toutes ses anciennes sous-routes. */}
              <Route path="/audrey/*" element={<Navigate to="/hub" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <ThemedToaster />
      <PWAStatus />
    </div>
    </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
